import { UserStore } from '@/store/user-module';
import { LookupStore } from '@/store/lookup-store';
import { StopwatchStore } from '@/store/stopwatch-store';
import { AccountStore } from '@/store/account-module';
import { AbsenceStore } from '@/store/absence-store';
import { ApprovalStore } from '@/store/approval-store';

export async function reloadGlobalData() {
  if (!UserStore.dataLoaded) {
    //TODO: sicherstellen, dass geänderte Einstellungen neu geladen werden.
    await UserStore.ensureUserData();
  }

  if (UserStore.isLoggedIn && !AccountStore.isLoaded) {
    // console.log('load acc')
    await AccountStore.reloadStore();
  }

  if (UserStore.isLoggedIn && !LookupStore.isLoaded) {
    // console.log('load lookup')
    await LookupStore.initializeStore();
  }

  if (UserStore.isLoggedIn && !StopwatchStore.isLoaded) {
    // console.log('load stopwatch')
    await StopwatchStore.initializeStore();
  }

  await AbsenceStore.getOpenAbsenceRequestCount();
  await ApprovalStore.getOpenApprovalRequestCount();
}

export function resetGlobalData() {
  UserStore.resetStore();
  LookupStore.reset();
  StopwatchStore.reset();
  AccountStore.reset();
}
